import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Login from './Login';
import { ForgotPassword } from './ForgotPassword';
import { APIPost } from '../../API';
import MeContext from '../../MeContext';
import AuthBody from '../../c/AuthBody';
import { AlertModal } from '../../c/Modals';
import { RenderIf } from '../../helpers/RenderIf';
import { getSavedUserName, saveLocalStorage } from '../../session';
import TwoFactorAuthentication from '../WhistlePage/TwoFactorAuth';
import { LL } from '../../c/LL';


const LoginPage = () => {
	const navigate = useNavigate();
	const presetUsername = getSavedUserName()
	const { setWhoami } = useContext(MeContext);
	const [showTwoFactorAuth, setShowTwoFactorAuth] = useState(false)
	const [user, setUser] = useState({ username: presetUsername, password: '', rememberMe: false });
	const [forgotPw, setForgotPw] = useState(false)
	const [forgotPwSent, setForgotPwSent] = useState(false)
	const [showLoading, setShowLoading] = useState(false)
	const [alertType, setAlertType] = useState({ type: "", text: "" })
	const [showAlert, setShowAlert] = useState(false)
	const [codeStatus, setCodeStatus] = useState(undefined);
	const [userAuth, setUserAuth] = useState({ user_id: undefined, two_fa_methods: [], picked_two_method: undefined })

	const sendEmail = (username) => {
		setShowLoading(true);
		APIPost("forgot-password", { username }).then(res => {
			setAlertType({ text: "An email has been sent", type: "success" })
			setShowAlert(true)
			setShowLoading(false)
			setForgotPwSent(true)
		}).catch(err => {
			setAlertType({ text: err.response.data, type: "error" })
			setShowAlert(true)
			setShowLoading(false)
			console.log(err)
		})
	}

	const sendCode = (userAuth) => {
		setCodeStatus("code sent")
		const userId = userAuth.user_id
		userAuth["action"] = "create_auth"
		setShowLoading(true)
		APIPost("user/" + userId + "/auth", userAuth).then(res => {
			setShowLoading(false)
		}).catch(err => {
			console.log(err)
			setShowLoading(false)
			setAlertType({ text: err.response.data, type: "error" })
			setShowAlert(true)
		})
	}

	const handleLogin = (twoFactorCode = undefined) => {
		setShowLoading(true);
		APIPost('login', user)
			.then((response) => {
				console.log(response)
				setShowLoading(false)
				setUserAuth(response.data)
				setShowTwoFactorAuth(true)
			})
			.catch((err) => {
				console.log(err)
				setShowLoading(false)
				setAlertType({ text: err.response.data, type: "error" })
				setShowAlert(true)
			});
	};

	const handleConfirmAuthCode = (authCode) => {
		const resource = "login/" + userAuth.user_id
		setShowLoading(true);
		APIPost(resource, authCode).then(res => {
			const session_id = res.data.session_id
			setWhoami(res.data)
			if (user.rememberMe) {
				saveLocalStorage(user.username, true)
				
			}
			saveLocalStorage(session_id)
			setTimeout(() => navigate(LL('/dashboard')), 500);
		}).catch(err => {
			setShowLoading(false)
			setCodeStatus("invalid code")
			setAlertType({ text: err.response.data, type: "error" })
			setShowAlert(true)
		})
	}

	return (
		<>
			<AuthBody showLoading={showLoading}>
				<RenderIf condition={!forgotPw}>
					<RenderIf condition={showTwoFactorAuth}>
						<TwoFactorAuthentication
							codeStatus={codeStatus}
							sendCode={sendCode}
							confirmAuthCode={handleConfirmAuthCode}
							userAuth={userAuth}
							cancel={() => setShowTwoFactorAuth(false)}
						/>
					</RenderIf>
					<RenderIf condition={!showTwoFactorAuth}>
						<Login
							user={user}
							setUser={setUser}
							handleLogin={handleLogin}
							setForgotPw={setForgotPw}
						/>
					</RenderIf>
				</RenderIf>
				<RenderIf condition={forgotPw}>
					<ForgotPassword
						preSetUsername={user.username}
						setForgotPw={setForgotPw}
						sendEmail={sendEmail}
						forgotPwSent={forgotPwSent}
					/>
				</RenderIf>
			</AuthBody>
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={alertType.type}
				text={alertType.text}
			/>
		</>
	);
};

export default LoginPage;
